import React from 'react'
import { InformationBanner } from '@chegg/fanta'
import { connect } from 'react-redux'
import { CITATION_LIST_NAME_LOWER_PLURAL } from '@chegg-wt/core/constants/citations'
import { dataMigrationIsInProgressSelector } from '@chegg-wt/core/state/user/selectors'
import * as Styled from './styled'

interface MigrationBannerProps {
  dataMigrationIsInProgress: boolean
}

export const MigrationNotificationBanner: React.FC<MigrationBannerProps> = ({
  dataMigrationIsInProgress,
}) =>
  dataMigrationIsInProgress ? (
    <InformationBanner size="large" title="Ongoing Maintenance">
      <Styled.Text data-test="migration-banner-text">
        We&apos;re currently performing database maintenance, and some of your{' '}
        {CITATION_LIST_NAME_LOWER_PLURAL} may not be immediately available. Please check
        back in a few minutes.
      </Styled.Text>
    </InformationBanner>
  ) : null

const mapStateToProps = (state) => ({
  dataMigrationIsInProgress: dataMigrationIsInProgressSelector(state),
})

export default connect(mapStateToProps)(MigrationNotificationBanner)
